// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16jlE","placeholdersHeader":"styles_placeholdersHeader__1fBxL","editorStyle":"styles_editorStyle__1UkvB","placeholdersBox":"styles_placeholdersBox__3a1pU"};